import React, {Fragment, useEffect, useRef} from 'react';
import {CustomModal} from "../../../shared";
import {FormattedMessage} from "react-intl";
import {useDispatch, useSelector} from "react-redux";
import group from "../../index";
import functions from "../../../../utils/functionsFirebase";
import GroupCard from "../../groupCard/groupCard";

function GroupInvites({groupInvites}) {

    const dispatch = useDispatch();

    const groupInvitesDetails = useSelector(group.selectors.getInviteDetails);
    const userGroups = useSelector(group.selectors.userGroups);
    const closeButton = useRef();

    useEffect(() => {
        async function fetchGroupInvites() {
            const newInviteDetails = [];

            for (let i in groupInvites) {
                const x = groupInvites[i];
                try {
                    let details = groupInvitesDetails.find(y => y.id === x);
                    if (!details) {
                        const getGroupSummary = functions.httpsCallable('getGroupSummary');
                        const res = await getGroupSummary({groupId: x});
                        details = res.data.group;
                    }
                    newInviteDetails.push(details);
                } catch (e) {
                    userGroups.groupInvites.splice(i, 1);
                    continue;
                }
            }
            if (groupInvites.length !== userGroups.groupInvites.length) {
                dispatch(group.actions.loadedGroups(userGroups.userGroups, userGroups.askedGroups, userGroups.groupInvites));
            }
            dispatch(group.actions.setInviteDetails(newInviteDetails))
        }

        if (userGroups.groupInvites.length === 0) {
            closeButton.current.click();
        }

        fetchGroupInvites();

    }, [groupInvites]);

    return (
        <div className="d-grid mb-3">

            {userGroups?.groupInvites?.length > 0 &&
                <button className="btn btn-secondary btn-block position-relative"
                        data-bs-toggle="modal" data-bs-target="#modalInvitedGroups">You have been invited
                    to {groupInvites.length}&nbsp;
                    {groupInvitesDetails.length === 1 ?
                        <FormattedMessage id="group-invites.group"/> :
                        <FormattedMessage id="group-invites.groups"/>}
                    <i className="fa-solid fa-up-right-from-square ms-2"></i>
                    <span
                        className="position-absolute top-0 start-100 translate-middle p-2 bg-danger border border-light rounded-circle">
                    </span>
                </button>}

            <CustomModal modalName="modalInvitedGroups" content={
                <Fragment>
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="exampleModalLabel"><FormattedMessage
                            id="group-invites.modal-title"/></h1>
                        <button type="button" ref={closeButton} className="btn-close" data-bs-dismiss="modal"
                                aria-label="Close"></button>
                    </div>
                    <div className="modal-body">

                        {groupInvitesDetails.map(x => {
                            return <GroupCard key={x.id} group={x} joined={false} asked={false} invited={true}/>
                        })}
                    </div>
                </Fragment>
            }/>

        </div>
    )
}

export default GroupInvites;
